import script from "./BrowserContainer.vue?vue&type=script&setup=true&lang=ts"
export * from "./BrowserContainer.vue?vue&type=script&setup=true&lang=ts"

import "./BrowserContainer.vue?vue&type=style&index=0&id=27729a9e&lang=css"

const __exports__ = script;

export default __exports__